/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ChatThreadContentShareCandidatesResponse = zod.object({
  grantablePermissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .describe(
      'Permissions the caller holds on the content, and so may grant. Empty whenever `reachUserIds` is.',
    ),
  reachUserIds: zod
    .array(zod.uuid())
    .describe(
      "Reach user ids of the thread's live users, the caller excluded, who cannot read the content. Empty unless the caller is a live member holding SHARE on it.",
    ),
});

export type ChatThreadContentShareCandidatesResponse = zod.input<
  typeof ChatThreadContentShareCandidatesResponse
>;
export type ChatThreadContentShareCandidatesResponseOutput = zod.output<
  typeof ChatThreadContentShareCandidatesResponse
>;
